import styled from 'styled-components';
import {BGImageCenter, getStaticImage, BLACK, scrollbar} from '../../../../globalVariables/GlobalVariables';
import {actions} from '../../SendingPopup.css';
import {justifyEnd} from '../../../../globalVariables/GlobalFlex';
import {approveSend} from '../../icons/images';
import {tabsContainer} from '../sendingTabs/SendingTabs.css';

export const container = styled.div`
    height: calc(100% - 180px);
    padding: 40px 20px;
    text-align: center;
    ${scrollbar} 
`;

export const title = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${BLACK};
    text-align: center;
    line-height: 115.002%;
    padding-block-end: 20px;
`;

export const messageText = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

export const messageLine = styled.div`
    font-size: 14px;
    color: ${BLACK};
    margin-bottom: 8px;
    font-weight: 400;
    line-height: 115.002%;
    white-space: pre-wrap;
    word-wrap: break-word;
`;
export const buttons = styled(actions)`
    ${justifyEnd};
`;
export const header = styled(tabsContainer)`
    &::after {
        ${BGImageCenter(getStaticImage(approveSend),'contain')}
    }
`;